





















import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'SelectItem',
  props: {
    // This is in fact dbId
    id: {
      type: [String, Number],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['routes']),
    listItemClass(): string[] {
      return ['list-item', this.selected ? 'selected' : ''];
    },
  },
  methods: {
    getObjectUrl(type: String, id: string): string {
      return this.routes.sorInfo
        .replace('__OBJECT_TYPE__', type)
        .replace('__OBJECT_ID__', id)
        .replace('__TAB__', 'info');
    },
  },
});
